"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useSelectorStyle = () => {
    const theme = (0, material_1.useTheme)();
    const selectorStyles = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '16px 0px 0px',
        gap: '16px',
        position: 'relative',
        width: '390px',
        height: '73px',
    };
    const selectorInnerBoxStyles = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0px 24px',
        gap: '16px',
        minWidth: '390px',
        height: '40px',
    };
    const itemStyles = Object.assign({}, theme.qlub.typography.body_sm);
    return {
        selectorStyles,
        selectorInnerBoxStyles,
        itemStyles,
    };
};
exports.default = useSelectorStyle;
